import { useMemo } from 'react'
import { matchPath, useLocation } from 'react-router'
import { makeSpaceStreamId } from '@towns-protocol/sdk'
import { PATHS } from 'routes'

export const useSpaceIdFromPathname = () => {
    const { pathname } = useLocation()

    return useMemo(() => {
        const match = matchPath(`${PATHS.SPACES}/:spaceId/*`, pathname)
        const spaceId = match?.params.spaceId
        if (!match || !spaceId || spaceId === 'new') {
            return
        }

        if (spaceId.startsWith('0x')) {
            try {
                return makeSpaceStreamId(spaceId)
            } catch (error) {
                console.log('invalid space ID:', error)
                return undefined
            }
        }
        return spaceId
    }, [pathname])
}

export const useExploreIdFromPathname = () => {
    const { pathname } = useLocation()

    return useMemo(() => {
        const spaceId =
            matchPath(`${PATHS.EXPLORE}/:exploreId/*`, pathname)?.params.exploreId ??
            matchPath(`${PATHS.SPACES}/:_/${PATHS.EXPLORE}/:exploreId/*`, pathname)?.params
                .exploreId

        if (!spaceId || spaceId === 'new') {
            return
        }

        if (spaceId.startsWith('0x')) {
            try {
                return makeSpaceStreamId(spaceId)
            } catch (error) {
                console.log('invalid space ID:', error)
                return undefined
            }
        }
        return spaceId
    }, [pathname])
}

export function spaceIdFromPathname(pathname: string) {
    const match = matchPath(`${PATHS.SPACES}/:spaceId/*`, pathname)
    const spaceId = match?.params.spaceId

    if (!match || !spaceId || spaceId === 'new') {
        return
    }

    if (spaceId.startsWith('0x')) {
        return makeSpaceStreamId(spaceId)
    }
    return spaceId
}
